function CalendarWeekdayFiller({fillercount=1}){
  const arr = []
  for(let i=0; i<fillercount; i++) {
    arr.push(<div key={i} className="ncal-cell ncal-cell__filler" ></div>)
  }

  return arr
}

export default CalendarWeekdayFiller